import * as React from "react";
const SvgFiRrEnvelopeOpenDollar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-envelope-open-dollar_svg__a)">
      <path
        fill="#062147"
        d="M22.459 9.097 21 7.699V4c0-2.206-1.794-4-4-4H7C4.794 0 3 1.794 3 4v3.699L1.541 9.097A5.03 5.03 0 0 0 0 12.708V19c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5v-6.292a5.03 5.03 0 0 0-1.541-3.611M7 2h10c1.103 0 2 .897 2 2v8.243l-4.878 4.879a3.007 3.007 0 0 1-4.243 0l-4.878-4.879V4c0-1.103.896-2 1.999-2m15 17c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3v-6.292q0-.293.058-.579l6.407 6.407a4.98 4.98 0 0 0 3.536 1.462 4.98 4.98 0 0 0 3.536-1.462l6.407-6.407q.058.286.058.579V19zm-8-8a.77.77 0 0 0-.644-.76l-3.042-.507A2.76 2.76 0 0 1 7.999 7c0-1.654 1.346-3 3-3a1 1 0 0 1 2 0h.268c1.067 0 2.063.575 2.598 1.5a1 1 0 0 1-1.731 1.001 1 1 0 0 0-.867-.5h-2.268c-.551 0-1 .449-1 1 0 .378.271.698.644.76l3.042.507A2.76 2.76 0 0 1 16 11.001c0 1.654-1.346 3-3 3a1 1 0 0 1-2 0h-.268a3.01 3.01 0 0 1-2.598-1.499 1 1 0 0 1 1.731-1.001c.178.308.511.5.867.5H13c.551 0 1-.449 1-1z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-envelope-open-dollar_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrEnvelopeOpenDollar;
